import { GridCellParams, GridSingleSelectColDef } from '@mui/x-data-grid-pro';
import { v4 } from 'uuid';
import { DetailCTARenderer } from '../../../Compounds/UpstackDataGrid/CellRenderers/DetailCTARenderer';
import { standardOperators, datePickerOperator } from '../../../Compounds/UpstackDataGrid/helpers';
import { ComponentName, getMetaData } from '../../../Compounds/DetailsDrawer/detailsDrawersHelpers';
import { getDate, getFormattedDate } from '../../../../utils/helpers';

export const DefaultUserGridColumnDefs: GridSingleSelectColDef[] = [
  {
    field: 'details',
    headerName: '',
    sortable: false,
    getOptionLabel: (value) => String(value),
    getOptionValue: (value) => value,
    width: 65,
    filterable: false,
    type: 'singleSelect',
    valueOptions: [],
    renderCell: (params: GridCellParams) => (
      <DetailCTARenderer
        data={params}
        value={''}
        valueFormatted={''}
        state={{
          id: v4(),
          data: params.row,
          ...getMetaData({ name: ComponentName.USER, id: params.row.id })
        }}
      />
    ),
    hideable: false,
    disableReorder: true
  },
  {
    field: 'firstName',
    headerName: 'First Name',
    sortable: true,
    getOptionLabel: (value) => String(value),
    getOptionValue: (value) => value,
    filterable: true,
    flex: 1,
    type: 'singleSelect',
    valueOptions: [],
    filterOperators: standardOperators(),
    description: 'Drag to move column'
  },
  {
    field: 'lastName',
    headerName: 'Last Name',
    sortable: true,
    getOptionLabel: (value) => String(value),
    getOptionValue: (value) => value,
    filterable: true,
    flex: 1,
    type: 'singleSelect',
    valueOptions: [],
    filterOperators: standardOperators(),
    description: 'Drag to move column'
  },
  {
    field: 'email',
    headerName: 'Email',
    sortable: true,
    getOptionLabel: (value) => String(value),
    getOptionValue: (value) => value,
    filterable: true,
    flex: 1,
    type: 'singleSelect',
    valueOptions: [],
    filterOperators: standardOperators(),
    description: 'Drag to move column'
  },
  {
    field: 'role',
    headerName: 'Role',
    filterable: true,
    getOptionLabel: (value) => String(value),
    getOptionValue: (value) => value,
    flex: 1,
    type: 'singleSelect',
    valueOptions: [],
    filterOperators: standardOperators(),
    description: 'Drag to move column'
  },
  {
    field: 'lastLogin',
    headerName: 'Last Login',
    sortable: true,
    getOptionLabel: (value) => String(value),
    getOptionValue: (value) => value,
    valueFormatter: (value) => {
      return getFormattedDate(value, 'lll');
    },
    valueGetter: (value) => {
      return value ? getDate(value).getTime() : '';
    },
    filterable: true,
    flex: 1,
    type: 'singleSelect',
    valueOptions: [],
    filterOperators: [datePickerOperator],
    description: 'Drag to move column'
  },
  {
    field: 'createdAt',
    headerName: 'Created At',
    sortable: true,
    getOptionLabel: (value) => String(value),
    getOptionValue: (value) => value,
    valueFormatter: (value) => {
      return getFormattedDate(value, 'lll');
    },
    valueGetter: (value) => {
      return value ? getDate(value).getTime() : '';
    },
    filterable: true,
    flex: 1,
    type: 'singleSelect',
    valueOptions: [],
    filterOperators: [datePickerOperator],
    description: 'Drag to move column'
  }
];
